let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lblbO")).then(() => parcelRequire('1dsYb'));